<template>
	<div class="health_index">
		<div class="health_index_header">
			<div class="health_index_header_contiainer">
                <img :src="require('assets/img/health/health_bg.png')" alt="">
                <!-- <div class="headr_logo"><img :src="require('@/assets/img/common/logo.png')" alt=""></div> -->
            </div>
            <div class="health_rule">
                <!-- <div class="mvbutton health_rule_btn" @click="showrule=true">活动规则</div> -->
            </div>
		</div>
		<div class="health_index_body">
			<!-- <div class="health_index_body_box">
				<div class="health_index_body_box_item">
					<div  class="health_index_body_box_item_notice">已看视频</div>
					<div  class="health_index_body_box_item_num"><span>{{myvideos}}</span>节</div>
					
				</div>	
				<div class="health_index_body_box_item">
					<div  class="health_index_body_box_item_notice">已看获取积分</div>
					<div  class="health_index_body_box_item_num"><span>{{mypoints}}</span></div>
					
				</div>	
			</div> -->
			<div class="health_index_body_item">
				<van-grid :border="false" :square="false" :column-num="4" gutter="0.01rem">
					<van-grid-item v-for="item in tabList" :key="item.vcid">
						<div class="health_index_body_item_tabs_tabcard" :class="{active:item.vcid*1==active}" @click="switchTab(item.vcid*1)">
							<span>{{item.title}}</span>
						</div> 
					</van-grid-item>
				</van-grid>
				<!-- <div class="health_index_body_item_tabs">
		                      
		        </div> -->
		        <van-skeleton avatar :row="1" v-if="videoList.length==0"/>
		        <van-list
		            v-else 
		          v-model="loading"
		          :finished="finished"
		          @load="onLoad"
		        >		        	
		    		<div v-for="(item,key) in videoList" :key="key" class="item_votelist_parent" @click="goDetail(item)">
			    		<div class="item_votelist">
			                <div class="votelist_videos">
			                    <van-image width="3rem" height="1.8rem" radius=".2rem" :src="item.imgurl"/>    
			                </div>           
			                <div class="votelist_title">
		                    	<div class="votelist_name">{{item.title}}</div>	                    	
			                </div>
							<div :class="['votelist_votes',item.urid?'':'active' ]">{{item.urid?'已观看':'未观看'}}</div>     
			            </div>
			        </div>
		        </van-list>
			</div>
		</div>
		<van-overlay :show="showrule"  >
            <div class="wrapper">
                <div class="block">
                    <div class="block_header">
                        <div>规则说明</div>
                        <img :src="require('assets/img/mwap/colse.png')" alt="" @click="showrule = false">
                    </div>
                    <div class="block_body" v-html="rule"></div>                    
                </div>                
            </div>
        </van-overlay>
	</div>
</template>
<script>
    import './index.less'
    import { Overlay, Image, List,Grid, GridItem  } from 'vant';  
    export default {
        data(){
			return {
				id:'',
				showrule:false,
				rule:'',
				tabList: [
				    {
				        'id': 1,
				        'title': '分类一',
				        'path':{params:{typeid:1}}
				    },
				    {
				        'id': 2,
				        'title': '分类二',
				        'path':{params:{typeid:2}}

				    },
				    {
				        'id': 3,
				        'title': '分类三',
				        'path':{params:{typeid:3}}
				    },
				    {
				        'id': 4,
				        'title': '分类四',
				        'path':{params:{typeid:4}}
				    },
				    {
				        'id': 5,
				        'title': '分类五',
				        'path':{params:{typeid:5}}
				    }
				],
				active: 1,
				loading: false,
                finished: false,
                page:1,
				videoList:[],
				myvideos:0,
				mypoints:0
			}
        },
        components:{
        	vanImage:Image,
            vanList:List,
            vanOverlay:Overlay,
			vanGrid:Grid, 
			vanGridItem:GridItem 
        },
        watch: {
        	active: function(newVal){
        		this.videoList =[]
        		if(this.tabList.length>0) this.getVideolist(this.active)
        	}
        },
        methods:{
            switchTab: function (e) {
                this.active = e;
                this.getVideolist(e)
                this.page = 1
            },
            getVideocat(){
            	this.$api.health.videocat().then((res) => {
                    if (res.status * 1 === 200) {
                    	this.tabList = res.data.list
						this.active = res.data.list[0].vcid
                    	this.mypoints = res.data.mypoints
                    	this.myvideos = res.data.myvideos
                    	this.rule = res.data.rule
                    	this.getVideolist()
                    }
                })
            },
            getVideolist(vcid){
				this.$api.health.videolist({vcid:this.active,page:this.page}).then((res) => {
                    if(res.status*1===200){
                        let list = res.data;
						this.videoList = list
						this.finished   =   true
                        // this.videoList = this.videoList.concat(list)
                        // if(res.data.pages*1>this.page){
                        //     this.page++
                        // }else{
                        //     this.finished   =   true
                        // }                        
                                         
                    }
                    this.loading = false;   
                })
            },
            onLoad() {
                if(this.finished) return;
                this.getVideolist();
            },
            goDetail(item){
            	this.$router.push({name:'healthdetail',params: {vid: item.vid,mediaurl: item.mediaurl}})
            }
        },
        mounted(){
            this.$nextTick(()=>{
            	this.getVideocat()
            })
        }
    }
</script>